
import EoPicture from "../../EoPicture/EoPicture.vue"

export default {
  name: "PreprPhoto",
  components: { EoPicture },
  props: {
    /**
     * Prepr data of this element
     */
    data: {
      type: Object,
      default: () => {},
    },
    /**
     * Prop and attribute overwrites
     */
    overwrites: {
      type: Object,
      default: () => {
        return {}
      },
    },
    /**
     * Index
     */
    index: {
      type: Number,
      default: null,
    },
  },
  data () {
    return {
      // Prepr data model https://developers.prepr.io/docs/rest/v1/fields-asset
      dataModel: {
        label: null,
        name: null, // Naam
        body: null, // Beschrijving
        author: null, // Bron
        height: 1,
        width: 1,
        cdn_files: {
          items: [{
            url: null,
          }],
        },
      },
    }
  },
  computed: {
    cData () {
      return {...this.dataModel, ...this.data}
    },
    cCaption () {
      /**
       * Merges description and credits to a caption.
       * (also makes sure the description ends with a period)
       */
      const caption = `
        ${this.cData.body ? this.cData.body.replace(/([^.])$/, '$1.') : ''}
        ${this.cData.author ? 'Credits: ' + this.cData.author.replace(/([^.])$/, '$1.') : ''}
      `
      return caption.trim()
    },
    cHeight () {
      return this.cData.height || 708
    },
    cWidth () {
      return this.cData.width || 1260
    },
    cImageSize () {
      return `${this.cWidth}x${this.cHeight}`
    },
  },
}
